import React from 'react';
import joi from 'joi-browser';
import { Form, Row, Col } from 'antd';
import { connect } from 'react-redux';
import Layout from '../Layout';
import EditForm from '../../components/EditForm';
import CardsList from '../Cards/components/CardsList';
import InfoItem from '../../components/InfoItem';
import IsApproved from '../../components/IsApproved';
import AddressFormItem from './components/Address/FormItem';
import { getById, save, resetState, resetSuccessSave } from '../../modules/places';
import { getCardsById } from '../../modules/placeCards';

class PlaceForm extends EditForm {
  validationSchema = joi.object({
    id: joi.number().default(null),
    // logo: joi.object().when('id', { is: null, then: joi.required() }),
    logo: joi.object()
      // .alternatives()
      // .try(joi.object(), joi.string())
      .when('id', { is: null, then: joi.required() }),
    delete_logo: joi.boolean().default(false),
    name: joi.string().trim().required(),
    description: joi.string().trim().required(),
    email: joi.string().trim().required(),
    phone_number: joi.string().trim().required(),
    address: joi.object(),
    /*address: joi.object().keys({
      line1: joi.string().trim().required(),
      line2: joi.string().trim().optional(),
      zip: joi.string().trim().required(),
      city: joi.string().trim().required(),
      state: joi.string().trim().required(),
      country: joi.string().trim().required(),
      coordinate: joi.object().keys({
        latitude: joi.number().required(),
        longitude: joi.number().required(),
      })
    })*/
  });

  styles = {
    ...this.styles,
    uploadForm: {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    },
  };

  static getDerivedStateFromProps(props, state) {
    const { data } = props;

    if (data && data.id) {
      /*if (data.address) {
        ['country', 'state', 'zip', 'city', 'line1', 'line2', 'full'].forEach((item) => {
          data[item] = data.address[item];
        });
      }*/

      return { data };
    }

    return null;
  }

  componentDidMount() {
    const { id } = this.props.match.params;

    if (id) {
      this.props.getById(id);
      this.props.getCardsById(id);
    }
  }

  render() {
    const { data, successSave, error } = this.props;
    const cards = this.props.cards.data.results;

    return (
      <Layout>
        <Form onSubmit={this.onSubmit}>
          {this.renderFormActions('Save')}
          {successSave && this.renderSuccessAlert('Place has been successfully saved.')}
          {error && this.renderErrorAlert(error)}
          <div className="container">
            <Row gutter={16}>
              <Col md={24} lg={12}>
                <InfoItem
                  label="Approved"
                  value={<IsApproved isApproved={data.approved} approve/>}
                  labelSpan={6}
                  valueSpan={18}
                />
                <div className="mb-minus-3">
                  {this.renderUpload('logo',
                    '.jpg, .png, .jpeg',
                    true,
                    'Upload Photo',
                    false,
                    this.styles.uploadForm,
                  'upload-place-logo')}
                </div>
                {this.renderInput('name', true, 'Name', null, null, 1)}
                {this.renderInput('description', true, 'Description', null, null, 2)}
                {this.renderInput('email', true, 'Email', null, null, 3)}
                {this.renderInput('phone_number', true, 'Phone Number', null, null, 4)}
                {this.renderComponent('address', 'Address', true, AddressFormItem, {
                  layout: {
                    labelSpan: 6,
                    valueSpan: 18
                  }
                })}
              </Col>
              <Col md={24} lg={12}>
                <CardsList cardsArray={cards} className="grid-list-ib card-list-sm"/>
              </Col>
            </Row>
          </div>
        </Form>
      </Layout>
    );
  }
}

export default connect(
  state => ({
    ...state.places,
    cards: state.placeCards,
  }),
  {
    getById,
    getCardsById,
    onSubmit: save,
    resetState,
    resetSuccessSave,
  },
)(PlaceForm);



// WEBPACK FOOTER //
// ./src/containers/Places/PlaceForm.js